/**-----------------------------------------------------------------------------------------
* Copyright © 2021 Progress Software Corporation. All rights reserved.
* Licensed under commercial license. See LICENSE.md in the project root for more information
*-------------------------------------------------------------------------------------------*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* tslint:disable:max-line-length */
var core_1 = require("@angular/core");
/**
 * Renders the selected value of the dropdown. To define the header template, nest an `<ng-template>` tag
 * with the `kendo<ComponentName>ValueTemplate` directive inside the component tag.
 *
 * The template context is set to the current component.
 * To get a reference to the current data item, use the `let-dataItem` directive.
 *
 * > The `ValueTemplate` directive can only be used with the DropDownList and DropDownTree components.
 *
 * - [Using `ValueTemplate` with the DropDownList]({% slug templates_ddl %}#toc-value-template)
 * - [Using `ValueTemplate` with the DropDownTree]({% slug templates_ddt %}#toc-value-template)
 *
 * @example
 * ```ts
 * _@Component({
 * selector: 'my-app',
 * template: `
 *  <kendo-dropdownlist [data]="listItems">
 *    <ng-template kendoDropDownListValueTemplate let-dataItem>
 *      <span>{{dataItem}} option</span>
 *    </ng-template>
 *  </kendo-dropdownlist>
 * `
 * })
 * class AppComponent {
 *   public listItems: Array<string> = ["Item 1", "Item 2", "Item 3", "Item 4"];
 * }
 * ```
 */
var ValueTemplateDirective = /** @class */ (function () {
    function ValueTemplateDirective(templateRef) {
        this.templateRef = templateRef;
    }
    ValueTemplateDirective = tslib_1.__decorate([
        core_1.Directive({
            selector: '[kendoDropDownListValueTemplate],[kendoDropDownTreeValueTemplate]'
        }),
        tslib_1.__metadata("design:paramtypes", [core_1.TemplateRef])
    ], ValueTemplateDirective);
    return ValueTemplateDirective;
}());
exports.ValueTemplateDirective = ValueTemplateDirective;
